import InformationIcon from './InformationIcon';

export default InformationIcon;
